module.exports = __webpack_public_path__ + "assets/gif_print.png";


//////////////////
// WEBPACK FOOTER
// ./images/gif_print.png
// module id = 316
// module chunks = 0